import React, { useState } from "react";
import "./style.css";
import {
  CustomLabel,
  regex_obj,
} from "../../Constant";
import CustomCard from "../../elements/CustomCard";
import StepperComponent from "../../component/StepperComponent";
import InputComponent from "../../component/InputComponent";
import { Radio, message } from "antd";
import { Lifetime_req_obj } from "../../RequestData";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  InitialState,
  onMinusButtonCall,
  onPlusButtonCall,
  setInitialState,
  setPlanData,
} from "../../Redux/CIReducer";
import TabComponent from "../../component/TabComponent";
import { useGetDimensions } from "../../Hooks/useGetDemension";
import { useIsMobile } from "../../Hooks/useIsMobile";
import { getApi } from "../../service/ApiService";
import { endpoints } from "../../service/endpoints";
import { decryp } from "../../Constant/Encrypt";
import { Router } from "react-router-dom";
import { HTTPRequest } from "../../service/lib";

const AgePredict = (date) => {
  if (date == "") return "00";
  let newArr = date.split("/");
  let newDate1 = [newArr[1], newArr[0], newArr[2]];
  let new_date = newDate1.join("/");
  let newDate = moment().diff(new Date(new_date), "years");
  if (`${newDate}` == "NaN") {
    return "00";
  }
  return parseInt(newDate);
};

const AccidentShieldPage = () => {
  const [insuredCheck, setInsuredCheck] = useState("yes");
  const [ageError, setAgeError] = useState(false);
  const isMobile = useIsMobile();
  const REDIRECTION = process.env.REACT_APP_REDIRECTIO_BASE_URL;

  const dispatch = useDispatch();
  // const plandata = useSelector((state) => state.CI.plandata);
  //const [userData, setUserData] = useState(plandata);
  const agentDataSelected = useSelector((state) => state.agData.agentData);
  const obj = {
    dob: "",
    gender: "",
    relationship: "",
    annualI: "",
    si: "",
  };
  const [userData, setUserData] = useState({
    adult: 1,
    child: 0,
    adultData: [obj],
    childData: [],
    pincode: "",
    dropDownopen: false,
    // email: "",
    // phn: "",
    check: true,
    dropDownError: false,
  });
  const typeOfCalculator = useSelector((state) => state.common.type);
  const { adultMember, childMember } = useSelector((state) => state.CI);
  const headerHeight = useGetDimensions("banner", 0).height;
  const CI_coverType = useSelector((state) => state.CI.coverType);

  const ApiCall = async () => {
    let agevalidationOutput = validateIndividualDate();
    if (
      !ValidateAllInput() ||
      userData.pincode.length !== 6 ||
      !agevalidationOutput
    ) {
      return message.error("Please provide required information");
    }
    if (!userData.phn) {
      return message.error("Please provide mobile number");
    }
    if (!userData.email) {
      return message.error("Please provide email Id");
    }
    if (!regex_obj.pincode.test(userData.pincode)) {
      return message.error("Please provide valid pincode");
    }
    if (!regex_obj.phoneNumberValid.test(userData.phn)) {
      return message.error("Please provide valid mobile number");
    }
    if (!regex_obj.emailValidation.test(userData.email)) {
      return message.error("Please provide valid email Id");
    }
    dispatch(setPlanData(userData));
    try {
      /* const res = await getApi(
        `sellonline/v1/location-details/${userData.pincode}/app/all`
      ); */
      const pincode_url= `sellonline/v1/location-details/${userData.pincode}/app/all`
      const res_data = await HTTPRequest.GET("pincode", pincode_url);
      let res = res_data.response;
      if (res) {
        const obj = Lifetime_req_obj({
          userData,
          type: typeOfCalculator,
          zone: res.zonecd,
          agentData: agentDataSelected,
          CI_coverType: CI_coverType.toLowerCase().includes("family") ? "familyfloater":CI_coverType,
        });
        
         const url = `${REDIRECTION}sell-accidental-shield/quick-quote/your-quote?q=${obj}`;
         if(url.includes(REDIRECTION)){
          window.location.href = url;
        }
      }
    } catch (err) {
      console.error(err);
      message.error("Service unavailable for this Pincode");
    }
  };
  const validateIndividualDate = () => {
    const age_check = userData.adultData.every(
      (ei) => AgePredict(ei.dob) <= 70
    );
    const childtAgeCheck = userData.childData.every((ei) => (AgePredict(ei.dob) <= 25 && AgePredict(ei.dob) >= 5));
    return age_check && childtAgeCheck;
  };
  const ValidateAllInput = () => {
    const data_A = userData.adultData.every(
      (ei) => ei.dob !== "" && ei.gender !== "" && ei.relationship !== ""
    );
    const data_C = userData.childData.every(
      (ei) => ei.dob !== "" && ei.gender !== "" && ei.relationship !== ""
    );

    if (
      userData.adultData
        .filter((ei) => ei.annualI > 0)
        .some((ei) => !(ei.annualI >= 125000 && ei.annualI <= 100000000))
    ) {
      return;
    }
    // const adultAgeCheck = true
    const age_check = userData.adultData.every(
      (ei) => AgePredict(ei.dob) <= 70
    );
    const adultAgeCheck = userData.adultData
      .filter((ei) =>
        ["son", "daughter"].includes(
          ei.relationship.toLocaleLowerCase()
        )
      )
      .every((ei) => AgePredict(ei.dob) <= 25);
      const childtAgeCheck = userData.childData.every((ei) => (AgePredict(ei.dob) <= 25 && AgePredict(ei.dob) >= 5));
    setAgeError(!(data_A && data_C && adultAgeCheck && age_check && childtAgeCheck));

    return data_A && data_C && adultAgeCheck && age_check && childtAgeCheck;
  };

  const handleKeyNumber = (e) => {
    var firstDigit = e.target.value.charAt(0);

    if (
      firstDigit === "0" ||
      firstDigit === "1" ||
      firstDigit === "2" ||
      firstDigit === "3" ||
      firstDigit === "4" ||
      firstDigit === "5"
    ) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      setUserData({ ...userData, phn: e.target.value });
    }
  };

  const okButtnClick = () => {
    if (!ValidateAllInput()) {
      return message.error("Please provide required information");
    }
    setUserData({ ...userData, dropDownopen: false });
  };

  const setMinusButton = (e) => {
    if (e === "Adult" && parseInt(userData.adult) === 1) {
      return message.error("Need to select atleast one Adult");
    }
    dispatch(onMinusButtonCall({ type: e }));
  };

  const setPlusButton = (e) => {
    if (parseInt(userData.adult) + parseInt(userData.child) >= 8) {
      return message.error("You had selected maximum member");
    }
    dispatch(onPlusButtonCall({ type: e }));
  };

  useEffect(() => {
    dispatch(InitialState());
    dispatch(onMinusButtonCall({ type: "Adult" }))
    dispatch(onMinusButtonCall({ type: "Child" }))
    setUserData({
      ...userData,
      adult: adultMember.length,
      adultData: adultMember,
      child: childMember.length,
      childData: childMember,
    });
   
  }, []);

  useEffect(() => {
    setUserData({
      ...userData,
      adult: adultMember.length,
      adultData: adultMember,
      child: childMember.length,
      childData: childMember,
    });
  }, [adultMember, childMember]);

  return (
    <div
      className="bg-color py-4 font-family"
      style={{ marginTop: `${parseInt(headerHeight)}px` }}
    >
      {/* <CustomToast /> */}
      <div className="row gx-2 container">
        <div className="col-xl-8 col-12">
          <div>
            <CustomLabel font_size="28" className="my-4">
              Accident Shield Quotation
            </CustomLabel>
          </div>
          <div className="col-12">
            <CustomCard>
              <div className="row mb-4">
                <div className="col-lg-6 col-12">
                  <div>
                    <CustomLabel font_size="14">
                      No of. members to secure &nbsp;&nbsp;
                      <CustomLabel font_size="12" color="#c3c2c2">
                        Age 18 & above is Adult
                      </CustomLabel>
                    </CustomLabel>
                  </div>
                  <div className="row">
                    <div className=" col-md-6 col-12">
                      <StepperComponent
                        plusClicked={(e) => setPlusButton("Adult")}
                        minusClicked={(e) => setMinusButton("Adult")}
                        label={"Adults"}
                        value={userData.adult}
                      />
                    </div>
                    <div className=" col-md-6 col-12">
                      <StepperComponent
                        plusClicked={(e) => setPlusButton("Child")}
                        minusClicked={(e) => setMinusButton("Child")}
                        label={"Kids"}
                        value={userData.child}
                      />
                    </div>
                    {userData.adult + userData.child > 1 && (
                      <div className=" col-12">
                        <TabComponent typeOfCalculator={typeOfCalculator}/>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6 col-12">
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <InputComponent
                        label={"Date of Birth & Gender"}
                        placeholder="Enter DOB & Gender"
                        value={
                          userData.adultData.length > 0
                            ? userData.adultData[0].dob
                            : userData.childData[0].dob
                        }
                        onChange={(e) => {
                          setUserData({ ...userData, dropDownopen: true });
                        }}
                        onCancel={(e) => {
                          setUserData({ ...userData, dropDownopen: false });
                        }}
                        onOk={() => {
                          okButtnClick();
                        }}
                        onDataChange={() => {}}
                        data={userData}
                        dropdownComponent={true}
                        dropDownopen={userData.dropDownopen}
                        readOnly={true}
                        ageError={ageError}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <InputComponent
                        label={"Pincode"}
                        regex={regex_obj.pincode}
                        placeholder="Enter Pincode"
                        value={userData.pincode}
                        onChange={(e) => {
                          setUserData({ ...userData, pincode: e.target.value });
                        }}
                        maxLength={6}
                      />
                    </div>
                    <div className="my-3">
                      <CustomLabel
                        font_size="12"
                        font_weight="bold"
                        color="#c3c2c2"
                      >
                        Same as mentioned in Aadhaar card / Passport / Driving
                        License or any other document
                      </CustomLabel>
                    </div>
                  </div>
                </div>
                {/* <div className="col-lg-10 col-12 d-inline-block">
                  <CustomLabel font_size="15" className="mx-2">
                    Is proposer is same as Insured?
                  </CustomLabel>
                  <Radio.Group
                    onChange={(e) => setInsuredCheck(e.target.value)}
                    value={insuredCheck}
                  >
                    <Radio value={"yes"}>Yes</Radio>
                    <Radio value={"no"}>No</Radio>
                  </Radio.Group>
                </div> */}
                <div
                  className={
                    isMobile ? "col-md-6 col-12 mb-4" : "col-md-6 col-12"
                  }
                >
                  <InputComponent
                    label={"Email"}
                    regex={regex_obj.emailValidation}
                    placeholder="Enter Your Email ID"
                    value={userData.email}
                    onChange={(e) => {
                      setUserData({ ...userData, email: e.target.value });
                    }}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <InputComponent
                    label={"Contact Number"}
                    regex={regex_obj.phoneNumberValid}
                    placeholder="Enter Your Phone Number"
                    value={userData.phn}
                    onChange={(e) => {
                      handleKeyNumber(e);
                    }}
                    extraData={true}
                    maxLength={10}
                  />
                </div>
              </div>
            </CustomCard>
            <div className="col-12 card_footer" onClick={ApiCall}>
              <CustomLabel color="white">
                {"Get Quotes".toLocaleUpperCase()}
              </CustomLabel>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccidentShieldPage;
